var exports = {
  "k": "x4c3adb35--b06d51--container",
  "A": "x4c3adb35--b06d51--item",
};

module.exports = exports;
